import {
	TUpsertThemeRequestBody,
	TUpsertThemeResponseBody,
} from '@kurtosys/types/api/applicationManager/UpsertTheme/index.js';

import { KsysRequest } from '../KsysRequest.js';

export class UpsertTheme extends KsysRequest<TUpsertThemeRequestBody, TUpsertThemeResponseBody> {
	getExplicitEndpoint = () => '/applicationManager/upsertTheme';
	get endpointConfiguration() {
		return this.getEndpointConfiguration('applicationManager', 'UpsertTheme');
	}
}
